import { render, staticRenderFns } from "./GeneratedFormItems.vue?vue&type=template&id=6f062cdd&scoped=true"
import script from "./GeneratedFormItems.vue?vue&type=script&lang=js"
export * from "./GeneratedFormItems.vue?vue&type=script&lang=js"
import style0 from "./GeneratedFormItems.vue?vue&type=style&index=0&id=6f062cdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f062cdd",
  null
  
)

export default component.exports